import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { useTheme } from "styled-components";
import Heading from "../../components/Heading/Heading";
import getThemeValue from "../../util/getThemeValue";
import { ModalBody, ModalHeader, ModalTitle, ModalContainer, ModalCloseButton, ModalBackButton } from "./styles";
import { useMatchBreakpoints } from "../../contexts";
export var MODAL_SWIPE_TO_CLOSE_VELOCITY = 300;
export var ModalWrapper = function(_param) {
    var children = _param.children, onDismiss = _param.onDismiss, minWidth = _param.minWidth, props = _object_without_properties(_param, [
        "children",
        "onDismiss",
        "minWidth"
    ]);
    var isMobile = useMatchBreakpoints().isMobile;
    var wrapperRef = useRef(null);
    return(// @ts-ignore
    /*#__PURE__*/ _jsx(ModalContainer, _object_spread_props(_object_spread({
        drag: isMobile ? "y" : false,
        dragConstraints: {
            top: 0,
            bottom: 600
        },
        dragElastic: {
            top: 0
        },
        dragSnapToOrigin: true,
        onDragStart: function() {
            if (wrapperRef.current) wrapperRef.current.style.animation = "none";
        },
        onDragEnd: function(e, info) {
            if (info.velocity.y > MODAL_SWIPE_TO_CLOSE_VELOCITY && onDismiss) onDismiss();
        },
        ref: wrapperRef,
        $minWidth: minWidth
    }, props), {
        children: children
    })));
};
var Modal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, onBack = _param.onBack, children = _param.children, _param_hideCloseButton = _param.hideCloseButton, hideCloseButton = _param_hideCloseButton === void 0 ? false : _param_hideCloseButton, _param_bodyPadding = _param.bodyPadding, bodyPadding = _param_bodyPadding === void 0 ? "24px" : _param_bodyPadding, _param_headerBackground = _param.headerBackground, headerBackground = _param_headerBackground === void 0 ? "transparent" : _param_headerBackground, _param_minWidth = _param.minWidth, minWidth = _param_minWidth === void 0 ? "320px" : _param_minWidth, props = _object_without_properties(_param, [
        "title",
        "onDismiss",
        "onBack",
        "children",
        "hideCloseButton",
        "bodyPadding",
        "headerBackground",
        "minWidth"
    ]);
    var theme = useTheme();
    return /*#__PURE__*/ _jsxs(ModalWrapper, _object_spread_props(_object_spread({
        minWidth: minWidth,
        onDismiss: onDismiss
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs(ModalHeader, {
                background: getThemeValue(theme, "colors.".concat(headerBackground), headerBackground),
                children: [
                    /*#__PURE__*/ _jsxs(ModalTitle, {
                        children: [
                            onBack && /*#__PURE__*/ _jsx(ModalBackButton, {
                                onBack: onBack
                            }),
                            /*#__PURE__*/ _jsx(Heading, {
                                children: title
                            })
                        ]
                    }),
                    !hideCloseButton && /*#__PURE__*/ _jsx(ModalCloseButton, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalBody, {
                p: bodyPadding,
                children: children
            })
        ]
    }));
};
export default Modal;
